import axios from "axios";
import { registerResponseInterceptor } from "@/api/axiosInterceptor";

const axiosInstance = axios.create({
  baseURL: `/gooduser/api`,
});

registerResponseInterceptor(axiosInstance);

export async function logIn(data) {
  const path = "/v3/login_chk_golfsamsung";

  return await axiosInstance.post(path, data);
}

export async function logOut() {
  const path = "/v1/logOut";

  return await axiosInstance.post(path);
}

export async function fetchNotices(params) {
  const path = "/v1/user/notices";

  return await axiosInstance.get(path, {
    params,
  });
}

export async function fetchNoticeDetails(params) {
  const path = "/v1/user/notices/detail";

  return await axiosInstance.get(path, {
    params,
  });
}

export async function fetchCategoriesV1(params) {
  const path = "/v1/category_api";

  return await axiosInstance.get(path, {
    params,
  });
}

export async function fetchTopSearches() {
  const path = "/v1/top_search/list";

  return await axiosInstance.post(path);
}

export async function fetchMainRecommendProducts(data) {
  const path = "/v1/promotion_api/main/recommend/list";

  return await axiosInstance.post(path, data);
}

export async function fetchMainNewProducts(data) {
  const path = "/v1/promotion_api/main/new/list";

  return await axiosInstance.post(path, data);
}

export async function fetchHotTagDetail(params) {
  const path = "/v1/promotion_api/hot_tag/detail";

  return await axiosInstance.post(path, params);
}

export async function fetchBags(data) {
  const path = "/v1/bag/list";

  return await axiosInstance.post(path, data);
}

export async function deleteBag(data) {
  const path = "/v1/bag/delete_one";

  return await axiosInstance.post(path, data);
}

export async function deleteBags(data) {
  const path = "/v1/bag/delete_multi";

  return await axiosInstance.post(path, data);
}

export async function orderInBags(data) {
  const path = "/v1/bag/buy_multi";

  return await axiosInstance.post(path, data);
}

export async function fetchOrderDetails({ paymentProductId, memberId }) {
  const path = `/v1/shipping_api/shipping_my_detail/${paymentProductId}`;

  return await axiosInstance.post(path, { memberId });
}

export async function fetchCancelOrders(data) {
  const path = `/v1/shipping_api/shipping_cancel_list`;

  return await axiosInstance.post(path, data);
}

export async function fetchShippingsV1(data) {
  const path = `/v1/shipping_api/shipping_my_list`;

  return await axiosInstance.post(path, data);
}

export async function fetchShippingCount(data) {
  const path = `/v1/shipping_api/shipping_my_list_count`;

  return await axiosInstance.post(path, data);
}

export async function fetchGiftCardOrderUsageMessage(data) {
  const path = `/v1/gift_api/select_gift_msg`;

  return await axiosInstance.post(path, data);
}

export async function fetchExhibitions(data) {
  const path = "/v1/promotion/exhibition/list";

  return await axiosInstance.post(path, data);
}

export async function fetchExhibitionDetail(data) {
  const path = "/v1/promotion/exhibition/detail";

  return await axiosInstance.post(path, data);
}

export async function addFavorite(data) {
  const path = "/v1/favorite/click_add";

  return await axiosInstance.post(path, data);
}

export async function cancelFavorite(data) {
  const path = "/v1/favorite/click_delete";

  return await axiosInstance.post(path, data);
}

export async function writeAboutAlliance(data) {
  const path = "/v1/alliance_qna/write";

  return await axiosInstance.post(path, data);
}

export async function uploadAttachment(file) {
  const path = "/v1/attachment/upload";
  const formData = new FormData();
  formData.append("attach", file);

  return await axiosInstance.post(path, formData);
}

export async function fetchFaqs(params) {
  const path = "/v1/faq";

  return await axiosInstance.get(path, {
    params,
  });
}

export async function fetchFaqDetails(params) {
  const path = "/v1/faq/detail";

  return await axiosInstance.get(path, {
    params,
  });
}

/**
 * 베스트 브랜드 조회
 * @param data
 */
export async function fetchBestBrands(data) {
  const path = "/v1/brand_api/best_brand";

  return await axiosInstance.post(path, data);
}

/**
 * 사용자 찜 브랜드/상품 조회
 * @param data
 */
export async function fetchUserLikeBrands(data) {
  const path = "/v3/favorite/checkProduct";

  return await axiosInstance.post(path, data);
}

/**
 * 내가 찜한 브랜드 목록 API
 * @param data
 */
export async function fetchMyFavoriteBrands(data) {
  const path = `/v1/favorite/brand_list/list`;

  return await axiosInstance.post(path, data);
}

/**
 * 사용자 브랜드 찜하기
 * @param data
 */
export async function postUserLikeBrand(data) {
  const path = "/v1/favorite/only_brand_click_add";

  return await axiosInstance.post(path, data);
}

/**
 * 사용자 브랜드 찜하기 취소
 * @param data
 */
export async function deleteUserLikeBrand(data) {
  const path = "/v1/favorite/brand_list/delete";

  return await axiosInstance.post(path, data);
}

/**
 * 사용자 브랜드 찜하기 전체취소
 * @param data
 */
export async function deleteAllUserLikeBrand(data) {
  const path = "/v1/favorite/brand_list/all_delete";

  return await axiosInstance.post(path, data);
}

/**
 * 브랜드 상세 조회
 * @param data
 */
export async function fetchBrand(data) {
  const path = "/v1/brand_api/brand";

  return await axiosInstance.post(path, data);
}

/**
 * 베스트 굿즈 리스트 조회
 */
export async function fetchBests(data) {
  const path = "/v1/product_api/best";

  return await axiosInstance.post(path, data);
}

export async function fetchFilterProductList(data) {
  const path = "/v1/product_api/product_list3";

  return await axiosInstance.post(path, data);
}

export async function fetchMainBestItemList(data) {
  const path = "/v1/main_api/best/list";

  return await axiosInstance.post(path, data);
}

/**
 * 이벤트 상세 조회
 * @param data
 */
export async function fetchEvent(data) {
  const path = "/v1/promotion/event/detail";

  return await axiosInstance.post(path, data);
}

/**
 * 추천인 등록 API
 * @param data
 */
export async function recommendUser({ userId, recommendUserId }) {
  const path = `/v1/users/${userId}/recommend-user`;

  return await axiosInstance.post(path, recommendUserId, {
    headers: { "Content-Type": "text/plain" },
  });
}

/**
 * 리뷰 목록 API
 * @param data
 */
export async function fetchReviews(data) {
  const path = `/v1/productreview/product_detail_review_list`;

  return await axiosInstance.post(path, data);
}

/**
 * 리뷰 작성 API
 * @param data
 */
export async function saveReview(data) {
  const path = `/v1/productreview/write`;

  return await axiosInstance.post(path, data);
}

/**
 * 리뷰 상세 API
 * @param data
 */
export async function fetchReviewDetail(data) {
  const path = `/v1/productreview/select`;

  return await axiosInstance.post(path, data);
}

/**
 * 리뷰 수정 API
 * @param data
 */
export async function updateReview(data) {
  const path = `/v1/productreview/update_btn`;

  return await axiosInstance.post(path, data);
}

/**
 * 리뷰 삭제 API
 * @param data
 */
export async function deleteReview(data) {
  const path = `/v1/productreview/delete_review_btn`;

  return await axiosInstance.post(path, data);
}

/**
 * 내 주소 목록 API
 * @param data
 */
export async function fetchMyShippingAddresses(data) {
  const path = `/v1/shipping_address_api/my_list`;

  return await axiosInstance.post(path, data);
}

/**
 * 내 주소 삭제 API
 * @param data
 */
export async function deleteMyShippingAddress(data) {
  const path = `/v1/shipping_address_api/delete`;

  return await axiosInstance.post(path, data);
}

/**
 * 내 주소 상세 API
 * @param data
 */
export async function fetchMyShippingAddressDetail(data) {
  const path = `/v1/shipping_address_api/detail`;

  return await axiosInstance.post(path, data);
}

/**
 * 내 주소 등록 API
 * @param data
 */
export async function saveMyShippingAddress(data) {
  const path = `/v1/shipping_address_api/save`;

  return await axiosInstance.post(path, data);
}

/**
 * 내 주소 등록 API
 * @param data
 */
export async function updateMyShippingAddress(data) {
  const path = `/v1/shipping_address_api/update`;

  return await axiosInstance.post(path, data);
}

/**
 * 골프장 픽업 날자 설정 API
 * @param data
 */
export async function setPickupDate(data) {
  const path = `/v1/shipping/golf_change`;

  return await axiosInstance.post(path, data);
}

/**
 * 기념일 수령 날자 설정 API
 * @param data
 */
export async function setAnniversaryShippingDate(data) {
  const path = `/v1/shipping/anniversary_change`;

  return await axiosInstance.post(path, data);
}

/**
 * 명절 수령 날자 설정 API
 * @param data
 */
export async function setHolidayShippingDate(data) {
  const path = `/v1/shipping/holiday_change`;

  return await axiosInstance.post(path, data);
}

/**
 * 골프 TV 채널 목록 (메인) API
 * @param data
 */
export async function fetchMainGolfTvChannels(data) {
  const path = `/v1/promotion_api/golf_tv/main`;

  return await axiosInstance.post(path, data);
}

/**
 * 골프 TV 채널 목록 API
 * @param data
 */
export async function fetchGolfTvChannels(data) {
  const path = `/v1/promotion_api/golf_tv/list`;

  return await axiosInstance.post(path, data);
}

/**
 * 골프 TV 채널 상세 API
 * @param data
 */
export async function fetchGolfTvChannelDetail(data) {
  const path = `/v1/promotion_api/golf_tv/detail`;

  return await axiosInstance.post(path, data);
}

/**
 * 선물 인증번호 확인 API
 * @param data
 */
export async function checkGiftCertNumber(data) {
  const path = `/v1/gift/chkNumber`;

  return await axiosInstance.post(path, data);
}

/**
 * 선물 거절 API
 * @param data
 */
export async function rejectGift(data) {
  const path = `/v1/gift/refuse_present`;

  return await axiosInstance.post(path, data);
}

/**
 * 선물 배송지 등록 API
 * @param data
 */
export async function saveGiftShippingAddress(data) {
  const path = `/v1/gift/insert`;

  return await axiosInstance.post(path, data);
}

/**
 * 재입고 알림 삭제 API
 * @param data
 */
export async function deleteRestockNotification(data) {
  const path = `/v1/stockNotify/delete`;

  return await axiosInstance.post(path, data);
}

/**
 * Q&A 작성 API
 * @param data
 */
export async function saveQnA(data) {
  const path = `/v1/qna_write`;

  return await axiosInstance.post(path, data);
}

/**
 * Q&A 삭제 API
 * @param data
 */
export async function deleteQnA(data) {
  const path = `/v1/qna_delete`;

  return await axiosInstance.post(path, data);
}

/**
 * Q&A 수정 API
 * @param data
 */
export async function updateQnA(data) {
  const path = `/v1/qna_edit`;

  return await axiosInstance.post(path, data);
}

/**
 * 선물 목록 API
 * @param data
 */
export async function fetchGiftList(data) {
  const path = `/v1/gift_api/myList0`;

  return await axiosInstance.post(path, data);
}

export async function fetchCourierCompanies() {
  const path = "/v1/courier-companies";

  return await axiosInstance.get(path);
}

/**
 * 푸시알림 목록 API
 * @param data
 */
export async function fetchPushNotifications(data) {
  const path = "/v1/push/list";

  return await axiosInstance.post(path, data);
}

/**
 * 푸시알림 삭제 API
 * @param data
 */
export async function deletePushNotification(data) {
  const path = "/v1/push/delete";

  return await axiosInstance.post(path, data);
}

/**
 * 휴일 조회 API
 * @param data
 */
export async function fetchHolidays(data) {
  const path = "/v1/holiday/select";

  return await axiosInstance.post(path, data);
}

/**
 * 상품 상세페이지에서 바로 구매를 한 경우, 사용.
 *
 *  바로 구매하기, 값 보내주기.
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function fetchValidBag(data) {
  const path = "/v1/product_api/user_buy_now/bag";

  return await axiosInstance.post(path, data);
}

/**
 * 장바구니 여러개 선택하고 구매하기 버튼 눌렀을 경우 호출되는 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function fetchValidMultiBag(data) {
  const path = "/v1/product_api/buy_multi_bag";

  return await axiosInstance.post(path, data);
}

/**
 * 결제하기 버튼 눌렀을 경우 호출되는 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function setPaymentSetting(data) {
  const path = "/v1/payment/setting";

  return await axiosInstance.post(path, data);
}

/**
 * 결제 완료 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function completePayment(data) {
  const path = "/v1/payment/complete";

  return await axiosInstance.post(path, data);
}

/**
 * 기프트 카드 목록 조회 API
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function fetchGiftCards() {
  const path = "/v1/giftcard/list";

  return await axiosInstance.get(path);
}

/**
 * 기프트 카드 검증 API
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function validateGiftCard(data) {
  const path = "/v1/giftCard/checkPoint";

  return await axiosInstance.post(path, data);
}

/**
 * 배송지 등록 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function saveAddress(data) {
  const path = "/v1/shippingAddress/write";

  return await axiosInstance.post(path, data);
}

/**
 * 선물하기 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function saveGift(data) {
  const path = "/v1/gift/write";

  return await axiosInstance.post(path, data);
}

/**
 * 선물하기 기프트 카드 이미지 조회 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function fetchGiftCardImages(data) {
  const path = "/v1/gift_image/list";

  return await axiosInstance.post(path, data);
}

/**
 * QnA 리스트 조회 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function fetchV3QnAs(data) {
  const path = "/v1/qna_list_v3";

  return await axiosInstance.post(path, data);
}

/**
 * QnA 비밀번호 체크
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function validateQnAPassword(data) {
  const path = "/v1/qna_chk";

  return await axiosInstance.post(path, data);
}

/**
 *
 * 상품 상세페이지에서 바로구매버튼으로 주문결제 페이지로 넘어갈 때 호출하는 API
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function fetchUserBuyNowBag(data) {
  const path = "/v3/product_api/user_buy_now";

  return await axiosInstance.post(path, data);
}

/**
 * 장바구니 담기 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function saveCartItem(data) {
  const path = "/v1/bag/add_cart";

  return await axiosInstance.post(path, data);
}

/**
 * 재입고 알림 요청 API
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function notifyProductStock(data) {
  const path = "/v1/stockNotify/save";

  return await axiosInstance.post(path, data);
}

/**
 * 추천 랜덤상품
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function randomProduct(data) {
  const path = "/v1/product_api/random";

  return await axiosInstance.post(path, data);
}

/**
 * 무이자 할부 안내 조회
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function setProductSettingAdminDetail() {
  const path = "/v1/product/setting/anywhere/detail";

  return await axiosInstance.post(path);
}

/**
 * fcm 토큰 저장
 * @param data
 * @return {Promise<axios.AxiosResponse<any>>}
 */
export async function saveFcmToken(data) {
  const path = "/v1/token/save";

  return await axiosInstance.post(path, data);
}

/**
 * 결제 트랜젝션 생성
 * @param {{ bagIds: number[] }} data
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function savePaymentTransaction(data) {
  const path = "/v1/bag/insert_total_payment_price";

  return await axiosInstance.post(path, data);
}

/**
 * KCP 모바일 결제 등록
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function registerKcpTrade(data) {
  const path = "/v1/payment/mobile/register";

  return await axiosInstance.post(path, data);
}

/**
 * 주문취소
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function cancelOrder({
  paymentProductGroup,
  userId,
  paymentProductId,
}) {
  const path = "v1/order/cancel";

  const formData = new FormData();
  formData.append("paymentProductGroup", paymentProductGroup);
  formData.append("memberId", userId);
  formData.append("paymentProductId", paymentProductId);
  return axiosInstance.post(path, formData);
}

/**
 * 주문취소(전체)
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function cancelAllOrder({
  paymentProductGroup,
  userId,
  paymentProductIds,
}) {
  const path = "v1/order/cancel";

  const formData = new FormData();
  formData.append("paymentProductGroup", paymentProductGroup);
  formData.append("memberId", userId);
  paymentProductIds.forEach((id) => {
    formData.append("paymentProductId", id);
  });
  return axiosInstance.post(path, formData);
}
